import script from "./ListingDatasets.vue?vue&type=script&setup=true&lang=js"
export * from "./ListingDatasets.vue?vue&type=script&setup=true&lang=js"

import "./ListingDatasets.vue?vue&type=style&index=0&id=48dc0c2e&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48dc0c2e"]])

export default __exports__